import { SearchResult } from '@app/models/search-result';
import { Person, User } from '@microsoft/microsoft-graph-types';
import { Observable } from 'rxjs';

export class PersonExtended implements User {
  id?: string;
  displayName?: string;
  mail?: string;
  mobilePhone?: string;
  businessPhones?: string[];  // Matches property on Graph User type. Copied from Graph: NOTE: Although this is a string collection, only one number can be set for this property.
  officeLocation?: string;
  jobTitle?: string;
  department?: string;
  photoUrl?: string;
  photoUrl$?: Observable<any>;
  userPrincipalName?: string;
  fallbackUrl?: string;
  Expanded?: boolean;  // Used by top search
  SearchTermHits?: string[]; // used by our comma separated search

  static fromPerson(person: Person): PersonExtended {
    return {
      id: person.id,
      userPrincipalName: person.userPrincipalName,
      displayName: person.displayName,
      mail: person.scoredEmailAddresses ? person.scoredEmailAddresses.map(emailAddresses => emailAddresses.address).shift() : null,
      department: person.department,
      officeLocation: person.officeLocation,
      jobTitle: person.jobTitle,
      mobilePhone: person.phones ? person.phones.filter(p => p.type === 'mobile').map(p => p.number).shift() : null,
      businessPhones: person.phones ? person.phones.filter(p => p.type === 'business').map(p => [p.number]).shift() : null
    } as PersonExtended;
  }

  static fromSearchResult(searchResult: SearchResult): PersonExtended {
    return {
      fallbackUrl: searchResult.Path,
      userPrincipalName: searchResult.AccountName.indexOf('|') !== -1 ? searchResult.AccountName.split('|')[2] : searchResult.AccountName,
      displayName: searchResult.PreferredName,
      mail: searchResult.WorkEmail,
      photoUrl: searchResult.PictureURL,
      department: searchResult.Department,
      officeLocation: searchResult.BaseOfficeLocation,
      jobTitle: searchResult.JobTitle
    } as PersonExtended;
  }
}
